import React from "react";
import { MoreDetailTemplates } from "../../components/template/MoreDetailTemplates";
import CompletedMatchListDetailContent from "../../components/organisms/CompletedMatchListDetailContent";
import { useLocation } from "react-router";
const CompletedMatchListDetailPage = () => {
  const location = useLocation();
  const detailData = location.state.item;

  return (
    <MoreDetailTemplates pageTitle="운송매칭 내역 상세" isBack={true}>
      <CompletedMatchListDetailContent detailData={detailData} />
    </MoreDetailTemplates>
  );
};

export default CompletedMatchListDetailPage;
